import { alertConstants } from "../constants";

interface Action {
  type: string,
  message: string
};

export const alert = (state = {}, action: Action) => {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: "alert-success",
        message: action.message
      };
    case alertConstants.ERROR:
      return {
        type: "alert-danger",
        message: action.message
      }
    case alertConstants.CLEAR:
      return {}
    default:
      return state
  }
};